import { IFeature } from '@belong/types';
import { FONT_COLOURS } from '@belong/themes';
import { assertContentType } from '../../helpers/assertContentType';
import { FSystemIcon } from './elementSystemIcon.factory';

export const FFeature = (data: any): IFeature => {
  assertContentType(data, 'elementFeatureRow');
  const { icon, description, descriptionColor } = data.fields;

  return {
    id: data.fields.identifier,
    icon: icon && FSystemIcon(icon),
    description,
    descriptionColor: FONT_COLOURS[descriptionColor] || descriptionColor
  };
};
